export default {
  data: () => ({
    bookMessageListener: null,
  }),
  created() {
    this.iframeToBookingIndex = new WeakMap();
  },
  methods: {
    postMessageToShopFrame(message, bookingId) {
      if (bookingId === undefined || bookingId === null) {
        return;
      }

      const refName = `shopFrame${bookingId}`;
      const iframe = this.$refs[refName];
      const iframeElement = Array.isArray(iframe) ? iframe[0] : iframe;

      if (!iframeElement) {
        return;
      }

      try {
        const serializedMessage = JSON.stringify(message);
        iframeElement.contentWindow.postMessage(serializedMessage, "*");
      } catch (error) {
        this.$store.dispatch("error", error);
      }
    },
    setupBookMessageListener(bookingId) {
      const refName = `shopFrame${bookingId}`;
      const iframe = this.$refs[refName];
      const iframeElement = Array.isArray(iframe) ? iframe[0] : iframe;

      if (iframeElement && iframeElement.contentWindow) {
        this.iframeToBookingIndex.set(iframeElement.contentWindow, bookingId);
      }

      if (this.bookMessageListener) {
        return;
      }

      this.bookMessageListener = (event) => {
        try {
          const parsedData = typeof event.data === "string" ? JSON.parse(event.data) : event.data;
          const { type, dataType, data } = parsedData;

          if (type === "tora") {
            let messageBookingId = null;

            if (event.source && this.iframeToBookingIndex.has(event.source)) {
              messageBookingId = this.iframeToBookingIndex.get(event.source);
            } else if (event.source) {
              if (this.form && this.form.bookings) {
                for (let i = 0; i < this.form.bookings.length; i++) {
                  const booking = this.form.bookings[i];
                  if (booking.dialogOpen || booking.externalOrderId) {
                    const refName = `shopFrame${booking._id}`;
                    const iframe = this.$refs[refName];
                    const iframeElement = Array.isArray(iframe) ? iframe[0] : iframe;

                    if (iframeElement && iframeElement.contentWindow === event.source) {
                      messageBookingId = booking._id;
                      this.iframeToBookingIndex.set(event.source, booking._id);
                      break;
                    }
                  }
                }
              }
            }

            this.handleToraMessage({ dataType, data, event, bookingId: messageBookingId });
          }
        } catch (error) {
          console.debug("Message parsing skipped:", error);
        }
      };

      window.addEventListener("message", this.bookMessageListener);
    },
    handleToraMessage({ dataType, data, event, bookingId }) {
      if (dataType === "appReady" && data === true) {
        if (this.relationAccount && this.relationAccount.savedPassengers) {
          if (bookingId !== undefined && bookingId !== null) {
            this.postMessageToShopFrame(
              {
                type: "mango",
                dataType: "savedPassengers",
                data: this.relationAccount.savedPassengers,
              },
              bookingId
            );
          }
        }
      } else if (dataType === "bookingSaved") {
        const targetBookingId = bookingId !== undefined && bookingId !== null ? bookingId : this.currentBookingIndex;

        if (data && targetBookingId !== null) {
          const bookingIndex = this.form.bookings.findIndex((b) => b._id === targetBookingId);
          if (bookingIndex !== -1) {
            this.$set(this.form.bookings[bookingIndex], "externalOrderId", data);
            this.$store.dispatch("success", "Booking number saved successfully!");
            this.closeBookingDialog(bookingIndex);
          }
        }
      } else if (dataType === "countdown") {
        if (bookingId !== undefined && bookingId !== null) {
          this.$set(this.bookingCountdowns, bookingId, data);
        }
      } else if (dataType === "countdownExpired") {
        if (bookingId !== undefined && bookingId !== null) {
          const bookingIndex = this.form.bookings.findIndex((b) => b._id === bookingId);
          if (bookingIndex !== -1) {
            const externalBookingId = this.form.bookings[bookingIndex]?.externalOrderId;
            if (externalBookingId) {
              this.$store.dispatch("error", `Booking ${externalBookingId} has expired!`);
            }

            if (this.bookingCountdowns && bookingId in this.bookingCountdowns) {
              this.$delete(this.bookingCountdowns, bookingId);
            }

            if (this.removeBooking && typeof this.removeBooking === "function") {
              this.removeBooking(bookingIndex);
            }
          }
        }
      }
    },
  },
  beforeDestroy() {
    if (this.bookMessageListener) {
      window.removeEventListener("message", this.bookMessageListener);
      this.bookMessageListener = null;
    }
    if (this.iframeToBookingIndex) {
      this.iframeToBookingIndex = new WeakMap();
    }
  },
};
